import { NgModule } from '@angular/core';
import { IonicModule } from 'ionic-angular';
import { EbitMarginDataTableComponent } from './ebit-margin-data-table';
import {NgPipesModule} from 'ngx-pipes';

@NgModule({
  declarations: [
    EbitMarginDataTableComponent,
  ],
  imports: [
    IonicModule,
    NgPipesModule,
  ],
  exports: [
    EbitMarginDataTableComponent
  ]
})
export class EbitMarginDataTableComponentModule {}


// WEBPACK FOOTER //
// ./src/components/ebit-margin-data-table/ebit-margin-data-table.module.ts